import React, {useContext} from 'react'
import FormTranslationContext from "context/FormTranslationContext";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import NoticeCpvInput from "../../components/inputs/NoticeCpvInput";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import NoticeNumericInput from "../../components/inputs/NoticeNumericInput";
import NoticeTypography from "../../components/inputs/NoticeTypography";
import GridBlock from "components/GridBlock";

function OrderObjectDivided(
    {
        id,
        formikProps,
        index
    }) {

    const gId = (name) => id + "." + name;
    const {getDict} = useContext(FormTranslationContext)

    return (<>
        <GridBlock justify="space-evenly">
            <NoticeTypography formTrKey={id}>: {index + 1}</NoticeTypography>
        </GridBlock>

        <NoticeNumericInput
            formikProps={formikProps}
            id={gId("dealingValue")}
            required
        />
        <NoticeGlossaryInput
            id={gId("dealingValueCurrency")}
            formikProps={formikProps}
            items={getDict("SL.MO.043")}
            required
        />

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("orderSubjectDescription")}
            multiline
        />

        <NoticeCpvInput
            formikProps={formikProps}
            id={gId("mainCpv")}
            required
        />

        <NoticeCpvInput
            formikProps={formikProps}
            id={gId("additionalCpv")}
            multiple
        />
    </>)
}

OrderObjectDivided.propTypes = {};

export default OrderObjectDivided;
